
class VolumeDiscount {
  constructor() {
    // jQuery element references
    this.$tiers = null;
    this.$quantity = null;
    this.$totalPrice = null;
    this.$addToCartButton = null;
    this.$stepperMinus = null;
    this.$stepperPlus = null;
    this.$bundleSize = null;
    this.$minValue = null;
    this.$maxValue = null;
    this.$quantityTooLow = false;
    this.$quantityTooHigh = false;

    // Storage state
    this.pricePerUnit = 0;
    this.quantity = 0;
    this.discount = 0;
  }

  /**
   * Initialize the volume discount functionality
   */
  init() {
    // Cache jQuery elements
    this.$tiers = $('.js-volume-discounts-tiers');
    this.$quantity = $('.js-volume-discount-quantity');
    this.$totalPrice = $('.js-volume-discount-total-price');
    this.$addToCartButton = $('.add_to_cart_button');
    this.$stepperMinus = $('.js-volume-discount-stepper-minus');
    this.$stepperPlus = $('.js-volume-discount-stepper-plus');
    this.$minValue = parseInt(this.$quantity.attr('min')) || 0;
    this.$maxValue = parseInt(this.$quantity.attr('max')) || 0;
    this.$minProductPerCartNotification = $('.js-min-product-per-cart-notification');
    this.$maxProductPerCartNotification = $('.js-max-product-per-cart-notification');

    this.$bundleSize = $('.js-volume-discount-quantity').attr('step') || 1;
    // Only initialize if tiers container exists
    if (this.$tiers.length > 0) {
      this.bindEvents();
      // Initialize quantity and price from current values
      const initialQuantity = parseInt(this.$quantity.val()) || 0;
      this.updateQuantity(initialQuantity);

      const initialPrice = this.getPriceForQuantity(initialQuantity);
      if (initialPrice !== null) {
        this.updatePricePerUnit(initialPrice);
      }
      // Sync add-to-cart button data-quantity and data-price-per-unit on page load
      this.updateQuantityDisplay(initialQuantity * this.$bundleSize);
      this.updatePricePerUnit(initialPrice)
      // Update total price on page load
      this.updateTotalPrice();
      this.updateCheckbox();

      this.checkOnMinimumQuantity();
      this.checkOnMaximumQuantity();
      this.updateButtonState();
      this.$tiers.find('input[type="radio"]').prop('disabled', false);
    }
  }

  /**
   * Bind all event listeners
   */
  bindEvents() {
    // Handle tier selection change
    this.$tiers.on('change', (e) => {
      const $input = $(e.target);
      const quantity = $input.val();
      const visualQuantity = $input.data('visual-quantity');
      const price = $input.data('price');

      this.updateQuantity(quantity);
      this.updatePricePerUnit(price);
      this.updateQuantityDisplay(visualQuantity);
      this.updateTotalPrice();
      this.checkOnMinimumQuantity();
      this.checkOnMaximumQuantity();
      this.updateButtonState();
    });

    // Handle quantity input change
    this.$quantity.on('change', (e) => {
      const bundleSize = parseInt(this.$bundleSize) || 1;
      // let quantity = this.quantity * bundleSize;
      let quantity = parseInt(e.target.value) || 0;

      // I want to check if $quantity / $bundleSize is a round number
      if (quantity % bundleSize !== 0) {
        quantity = Math.round(quantity / bundleSize) * bundleSize;
      }

      this.$quantity.val(quantity);
      let bundleCount = quantity / bundleSize;

      this.updateQuantity(bundleCount);
      const price = this.getPriceForQuantity(bundleCount);

      if (price !== null) {
        this.updatePricePerUnit(price);
      }

      this.updateQuantityDisplay(bundleCount * bundleSize);
      this.updateCheckbox();
      this.updateTotalPrice();
      this.checkOnMinimumQuantity();
      this.checkOnMaximumQuantity();
      this.updateButtonState();
    });

    // Handle stepper minus button
    this.$stepperMinus.on('click', (e) => {
      e.preventDefault();
      this.decrementQuantity();

      const price = this.getPriceForQuantity(this.quantity);

      if (price !== null) {
        this.updatePricePerUnit(price);
      }
      const bundleSize = parseInt(this.$bundleSize, 10) || 1;
      this.updateQuantityDisplay(this.quantity * bundleSize);
      this.updateCheckbox();
      this.updateTotalPrice();
      this.checkOnMinimumQuantity();
      this.checkOnMaximumQuantity();
      this.updateButtonState();
    });

    // Handle stepper plus button
    this.$stepperPlus.on('click', (e) => {
      e.preventDefault();
      this.incrementQuantity();

      const price = this.getPriceForQuantity(this.quantity);

      if (price !== null) {
        this.updatePricePerUnit(price);
      }
      const bundleSize = parseInt(this.$bundleSize, 10) || 1;
      this.updateQuantityDisplay(this.quantity * bundleSize);
      this.updateCheckbox();
      this.updateTotalPrice();
      this.checkOnMinimumQuantity();
      this.checkOnMaximumQuantity();
      this.updateButtonState();
    });

    // Handle AJAX add to cart - send price with request
    $(document.body).on('adding_to_cart', (e, $button, data) => {
      // Check if this is a volume discount product
      if (this.$addToCartButton.length > 0 && $button.is(this.$addToCartButton)) {
        const pricePerUnit = parseFloat(this.$addToCartButton.attr('data-price-per-unit')) || 0;
        if (pricePerUnit > 0) {
          // Add price to the AJAX request data
          if (data && typeof data === 'object') {
            data.price_per_unit = pricePerUnit;
          }
        }
      }
    });
  }

  /**
   * Update quantity value
   */
  updateQuantity(quantity) {
    this.quantity = parseInt(quantity) || 0;
  }

  /**
   * Update price per unit
   */
  updatePricePerUnit(price) {
    this.pricePerUnit = price;
  }

  /**
   * Update discount value
   */
  updateDiscount(discount) {
    this.discount = discount;
  }

  /**
   * Get total price
   */
  getTotalPrice() {
    return this.pricePerUnit * this.quantity;
  }

  /**
   * Update the quantity display and add-to-cart button
   */
  updateQuantityDisplay(visualQuantity) {
    let url = this.$addToCartButton.attr('href');
    const quantity = this.quantity;
    const pricePerUnit = this.pricePerUnit;

    this.$quantity.val(visualQuantity);

    // Check if quantity parameter already exists
    if (url.includes('&quantity=') || url.includes('?quantity=')) {
      // Replace existing quantity parameter
      url = url.replace(/([?&])quantity=[^&]*/, '$1quantity=' + quantity);
    } else {
      // Append quantity parameter
      url = url + (url.includes('?') ? '&' : '?') + 'quantity=' + quantity;
    }

    // Add price per unit to URL for non-AJAX requests
    if (pricePerUnit > 0) {
      // Remove existing price_per_unit parameter if present
      url = url.replace(/([?&])price_per_unit=[^&]*/, '');
      // Append price_per_unit parameter
      url = url + (url.includes('?') ? '&' : '?') + 'price_per_unit=' + pricePerUnit;
    }
    this.$quantity.val(visualQuantity);
    this.$addToCartButton.attr('href', url);
    this.$addToCartButton.attr('data-quantity', quantity);
    
    // Store price per unit for AJAX add to cart
    if (pricePerUnit > 0) {
      this.$addToCartButton.attr('data-price-per-unit', pricePerUnit);
    }
  }

  /**
   * Update the total price display
   */
  updateTotalPrice() {
    const totalPrice = this.getTotalPrice();
    this.$totalPrice.text('€ ' + totalPrice.toFixed(2).replace('.', ','));
  }

  /**
   * Decrement quantity by 1
   */
  decrementQuantity() {
    const minValue = parseInt(this.$quantity.attr('min')) || 0;
    if ((this.quantity * this.$bundleSize) <= minValue) {
      return;
    }

    this.updateQuantity(this.quantity - 1);
  }

  /**
   * Increment quantity by 1
   */
  incrementQuantity() {
    const maxValue = parseInt(this.$quantity.attr('max')) || 0;
    if (maxValue && ((this.quantity + 1) * this.$bundleSize) > maxValue) {
      return;
    }

    this.updateQuantity(this.quantity + 1);
  }

  /**
   * Get price for a given quantity based on tier rules
   */
  getPriceForQuantity(quantity) {
    let price = null;
    this.$tiers.find('input[type="radio"]').each((index, element) => {
      const $input = $(element);
      const minQuantity = parseInt($input.data('min'), 10) || 0;
      const maxRaw = $input.data('max');

      const inTier =
        maxRaw === null || maxRaw === undefined || maxRaw === ''
          ? quantity >= minQuantity
          : quantity >= minQuantity && quantity <= parseInt(maxRaw, 10);

      if (inTier) {
        price = parseFloat($input.data('price'));
        return false;
      }
    });
    return price;
  }

  /**
   * Update checkbox/radio selection based on current quantity
   */
  updateCheckbox() {
    const quantity = this.quantity;
    this.$tiers.find('input[type="radio"]').each((index, element) => {
      const $input = $(element);
      const minQuantity = $input.data('min');
      const maxQuantity = $input.data('max');

      if (quantity >= minQuantity && quantity <= maxQuantity) {
        $input.prop('checked', true);
      } else {
        $input.prop('checked', false);
      }
    });
  }

  checkOnMinimumQuantity() {
    this.$quantityTooLow = parseInt(this.$quantity.val()) < this.$minValue;
  }

  checkOnMaximumQuantity() {
    this.$quantityTooHigh = this.$maxValue > 0 && parseInt(this.$quantity.val()) > this.$maxValue;
  }

  updateButtonState() {
    const outOfRange = this.$quantityTooLow || this.$quantityTooHigh;

    this.$addToCartButton.closest('.js-volume-discount-button-wrapper')
      .toggleClass('c-add-to-cart__button--disabled', outOfRange);
    this.$minProductPerCartNotification
      .toggleClass('c-product-info__min-product-per-cart--red', this.$quantityTooLow);
    this.$maxProductPerCartNotification
      .toggleClass('c-product-info__max-product-per-cart--red', this.$quantityTooHigh);
  }
}

// Initialize when document is ready
$(document).ready(function ($) {
  const volumeDiscount = new VolumeDiscount();
  volumeDiscount.init();
});
